import React, { useEffect, useState, useContext } from "react";
import "./Recommender.css";
import Header from "./Header";
import AgentDetails from "./AgentDetails";
import _, { set } from "lodash";
import { useLocation, useSearchParams } from "react-router-dom";
import { onecodeAPI } from "../AppConfig";
import { Modal, Spin } from "antd";
import Ineligilble from "./Ineligilble";
import { CloseOutlined } from "@ant-design/icons";
import Eligilble from "./Eligible";
import RecommendationCategoryCardV2 from "./RecommendationCategoryCardV2";
import RecommendationFilter from "./RecommendationFilter";
import { useTranslation } from "react-i18next";
import ApplyModal from "./ApplyModal";
import BackfillModal from "./BackfillModal";
import CreditScore from "./CreditScore";
import { FeatureFlagContext } from "../FeatureFlagContext";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { customerActions } from "../store/customerSlice";
import ContentModal from "../lf3/ContentModal";

let refreshIntervalId = null;
let lmsRefreshIntervalId = null;

let dataLoaded = null;
let recommendationsLoadStartTime = null;

export default function Recommendations({
  customerName = "Ankit",
  subtext = "Here are some top picks for you",
}) {
  const { flags } = useContext(FeatureFlagContext);
  const [hg, setHg] = useState([]);
  const [coc, setCoc] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [recommendations, setRecommendations] = useState([]);
  const [lmsRecommendations, setLmsRecommendations] = useState([]);
  const [customer, setCustomer] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [customerDetails, setCustomerDetails] = useState(null);
  const [onecode, setOnecode] = useState(null);
  const [internalStatus, setInternalStatus] = useState(null);
  const [brandInEligible, setBrandInEligible] = useState(false);
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  const [lmsBrandInEligible, setLmsBrandInEligible] = useState(false);
  // const [refreshIntervalId, setRefreshIntervalId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [lf5Url, setLf5Url] = useState("");
  const [brandSpecific, setBrandSpecific] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);
  const [existingAccount, setExistingAccount] = useState(false);
  const [closeIcon, setCloseIcon] = useState(false);
  const [selectedPartnerStatus, setSelectedPartnerStatus] = useState("");

  const [lmsExistingAccount, setLmsExistingAccount] = useState(false);
  const [LmsCloseIcon, setLmsCloseIcon] = useState(false);
  const [lmsSelectedPartnerStatus, setLmsSelectedPartnerStatus] = useState("");

  //New Recommendation UI
  const [interestsArray, setInterestsArray] = useState([]);
  const [initialRecommendation, setInitialRecommendation] = useState([]);
  const [lmsInitialRecommendation, setLmsInitialRecommendation] = useState([]);
  const [initialCount, setInitialCount] = useState(1);
  const [notEligible, setNotEligible] = useState([]);
  const [lmsNotEligible, setLmsNotEligible] = useState([]);

  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [emailHandlePopup, setEmailHandlePopup] = useState(false);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const { t, i18n } = useTranslation();
  const [shouldCallApplyPartner, setShouldCallApplyPartner] = useState(false);
  const [isCreditScoreCheck, setIsCreditScoreCheck] = useState(false);
  // const [ineligibleBrand, setIneligibleBrand] = useState([]);
  const [dropDownOptions, setDropDownOptions] = useState(null);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [stepCountForEvent, setStepCountForEvent] = useState(0);
  let recommendationStepCount = 0;
  const [isConditionalField, setIsConditionalField] = useState(false);
  const [partnerLink, setPartnerLink] = useState("");

  const { recommendationData,addCustomerFlow } = useSelector((state) => state.CUSTOMER); 
  const [handelContentModal, setHandelContentModal] = useState(false);
  const [responsePopContent, setResponsePopContent] = useState({
    heading: "",
    description: "",
    link:""
  });
  const dispatch = useDispatch();

  const checkNavigation = (e) => {
    if (responseStatus == 409) {
      setIsModalVisible(false);
      e.preventDefault();
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleEligiblePopupCancel = () => {
    setIsEligibleModalVisible(false);
  };

  const hideEmailHandlePopup = () => {
    setEmailHandlePopup(false);
  };

  // const [hash, setHash] = useState("");
  let location = useLocation();
  // 8ore7hMR8m1vq1agUcUaXVzr1JGzfRoGicOWxUuRe4f28yEJds4Usf8HGXkk15c4lndsHNrrglEiB%2BuS2eeNgA%3D%3D
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let partnerDetails = JSON.parse(sessionStorage.getItem("partnerDetails"));
  const attributionType = sessionStorage.getItem("attributionType")

  useEffect(() => {
    if (shouldCallApplyPartner && customerDetails) {
      checkBeforeApplyPartner();
    }
  }, [shouldCallApplyPartner, customerDetails]);

  const checkBeforeApplyPartner = () => {
      applyToPartner();
  };


  const query = useQuery();
  useEffect(() => {
    // let query = useQuery();
    // setHash(query.get("hash"));
    let hash = _.get(location, "state.hash");
    let isCreditScoreCheck = _.get(location, "state.isCreditScoreCheck");
    // console.log(isCreditScoreCheck,"isCreditScoreCheck====");
    if (sessionStorage.getItem("isCreditScoreCheck")) {
      setIsCreditScoreCheck(true);
    }
    if (isCreditScoreCheck) {
      setIsCreditScoreCheck(isCreditScoreCheck);
    }
    if (hash) {
      setSearchParams({ hash: hash });
    }
  }, []);

  useEffect(() => {
    if (customer) {
      window?.Moengage?.track_event("customer_recommendations_page_view", {
        customer_name: customer?.fullName,
        customer_phone: customer?.phoneNumber,
      });
    }
  }, [customer]);

  useEffect(() => {
    if (dataLoaded == null && recommendations?.length > 0 && customer) {
      window?.Moengage?.track_event("customer_recommendations_data_loaded", {
        customer_name: customer?.fullName,
        customer_phone: customer?.phoneNumber,
        isAddCustomerFlow: addCustomerFlow,
        pollingCount: stepCountForEvent,
      });
      dataLoaded = true;
      setStepCountForEvent(0);
      dispatch(customerActions.setAddCustomerFlow(false));
    }
  }, [recommendations]);

  useEffect(() => {
    if (searchParams.get("hash")) {
      getCustomerExistingDetails();
    }
  }, [searchParams]);

  const getCustomerExistingDetails = async () => {
    try {
      setLoading(true);
      const hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post(`/public/customer/findByHash`, {
        hash: hash,
      });
      let missingFields = res?.data?.missingFields ?? [];
      missingFields = [...missingFields];
      setCustomerDetails(res.data);
      setAdditionalFields(missingFields);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errror-customer", error);
    }
  };
  useEffect(() => {
    if (searchParams.get("hash")) {
      recommendationsLoadStartTime = moment();
    }
    refreshIntervalId = setInterval(() => {
      if (recommendationStepCount < 10 && searchParams.get("hash")) {
        recommendationStepCount += 1;
        getCustomerRecommendations(recommendationStepCount);
      } else {
        clearInterval(refreshIntervalId);
      }
    }, 2000);
    return () => {
      clearInterval(refreshIntervalId);
    };
  }, [searchParams]);

  // If the Brand is Eligible
  const applyToPartner = async () => {
    let response;
    let hash = encodeURIComponent(searchParams.get("hash"));
    // console.log("partnerDetails", partnerDetails);
    let partnerId = partnerDetails?.id;

    if (partnerDetails?.shareContent?.getLink) {
      setLoading(true);
      let res = await onecodeAPI.post("/public/loanwiser/shareLink", {
        hash,
        partnerId,
      });

      let l = _.get(res, "data");
      let v = l + "&req_id=%7Bclick_id%7D";
      setLoading(false);
      setIsModalVisible(true);
      setPartnerLink(v);
    }else if(partnerDetails?.isExternalLeadCapture){
      let link=partnerDetails?.itemUrl
      const newLink= _.replace(link,"{{ONECODE}}",onecode)
      setIsModalVisible(true);  
      setPartnerLink(newLink);
    }
    
    else if (partnerDetails?.leadFlow === "LF5") {
      try {
        setLoading(true);
        let resp = await onecodeAPI.post("public/customer/generateLink", {
          hash,
          partnerId,
        });
        let statusCode = _.get(resp, "data.statusCode");
        let notEligibleReasons = _.get(resp, `data.message`, []);
        let dataIssue = _.get(resp, "data.message", "");
        let editLink = _.get(resp, "data.url", "");
        setBrandNotEligibleReasons(notEligibleReasons || []);
        if (statusCode == 3307) {
          if (resp.data?.url) {
            window.open(resp?.data?.url);
          }
          return null;
        } else if (statusCode == 3308) {

          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Invalid data",
            description: dataIssue ? dataIssue : "",
            link:editLink
          });
          return null;
        } else if (statusCode == 3309) {
          // setIsModalVisible(true);
          setIsEligibleModalVisible(true);
          // setBrandNotEligiblePopup(true);
          return null;
        } else if (statusCode == 3310) {
          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Issue",
            description: dataIssue ? dataIssue : "",
            link:""
          });
        }
        if (resp?.data?.url) {
            setPartnerLink(resp?.data?.url);
            setIsModalVisible(true);
        }
        setLoading(false);
      } catch (error) {
        setIsModalVisible(true);
        setLoading(false);
        if (error?.response?.status == 409) {
          setResponseStatus(error?.response?.status);
        }
        console.log(error);
      }
    } else {
      try {
        setLoading(true);
        response = await onecodeAPI.post(`/public/getShareLink`, {
          hash,
          partnerId,
        });
        setIsModalVisible(true);
        setLoading(false);
        setPartnerLink(response.data);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
  };

  const filterEligiblePartners = (categories, eligiblePartners) => {
    const filteredPartnersInCategories = _.map(categories, (category) => {
      return {
        ...category,
        partners: _.filter(category.partners, (partner) =>
          eligiblePartners?.includes(partner?.id)
        ),
      };
    });
    const filteredEligibleCategories = _.filter(
      filteredPartnersInCategories,
      (category) => category?.partners?.length > 0
    );
    return filteredEligibleCategories;
  };

  // useEffect(() => {
  //   if (
  //     (lmsInternalStatus == 2019 ||
  //       lmsInternalStatus == 2020 ||
  //       lmsInternalStatus == 2022) &&
  //     lmsRefreshIntervalId == null
  //   ) {
  //     lmsRefreshIntervalId = setInterval(checkLMSRecommendation, 1000 * 5);
  //   }
  // }, [lmsInternalStatus]);

  // const onLMSBrandsClick = async () => {
  //   let hash = encodeURIComponent(searchParams.get("hash"));
  //   try {
  //     const res = await onecodeAPI.post(`/public/customer/verifyApi?`, {
  //       hash: hash,
  //       partnerId: partnerDetails?.id,
  //     });
  //     if (res.data?.data?.url) {
  //       window.open(res.data?.data?.url, "_blank");
  //     }
  //   } catch (error) {
  //     console.log(error, "error---");
  //   }
  // };

  // const checkLMSRecommendation = async () => {
  //   let hash = encodeURIComponent(searchParams.get("hash"));
  //   let recommendedBrands = [];
  //   // setDataLoading(true);
  //   try {
  //     const res = await onecodeAPI.post(
  //       `/public/customer/lms/recommendations`,
  //       {
  //         hash: hash,
  //         partnerId: partnerDetails?.id,
  //       }
  //     );
  //     const eligibleBrands = _.get(res, `data.eligibleBrands`, []);
  //     const notEligiblePartners = _.get(res, `data.notEligiblePartners`, []);

  //     const notEligibleReasons = _.get(res, `data.message`, []);
  //     const partnerStatus = _.get(res, `data.partnerStatus`, []);
  //     const leadAddedBrands = _.map(partnerStatus, "partnerId");

  //     setBrandNotEligibleReasons(notEligibleReasons || []);
  //     let resStatus = _.get(res, "status", "");
  //     if (resStatus == 200) {
  //       let internalStatus = _.get(res, "data.status", null);
  //       setLmsInternalStatus(internalStatus);
  //       if (
  //         internalStatus == 2019 ||
  //         internalStatus == 2020 ||
  //         internalStatus == 2022
  //       ) {
  //         // setDataLoading(true);
  //       } else if (internalStatus == 2028) {
  //         onLMSBrandsClick();
  //       } else if (internalStatus == 2027) {
  //         setEmailHandlePopup(true);
  //         // setDataLoading(false);
  //       } else {
  //         // setDataLoading(false);
  //         clearInterval(lmsRefreshIntervalId);
  //         const isEligibleBrand = eligibleBrands?.includes(
  //           Number(partnerDetails?.id)
  //         );
  //         if (
  //           isEligibleBrand ||
  //           leadAddedBrands?.includes(partnerDetails?.id)
  //         ) {
  //           applyToPartner();
  //         } else {
  //           setIsEligibleModalVisible(true);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setDataLoading(false);
  //     clearInterval(lmsRefreshIntervalId);
  //   }
  // };

  const validateCustomer = (hash) => {
    return hash === recommendationData?.customer;
  };

  const getCustomerRecommendations = async (
    recommendationStepCount = false
  ) => {
    setDataLoading(true);
    let rec = {};
    let response;
    const hash = encodeURIComponent(searchParams.get("hash"));
    let preloaded = false;

    try {
      if (recommendationData && validateCustomer(hash)) {
        response = recommendationData;
        preloaded = true;
      } else {
        response = await onecodeAPI.post(`public/customer/recommendations`, {
          hash,
          locale: i18n?.language || "en",
        });
        const hg = _.get(response, `data.hg`, []);
        const coc = _.get(response, `data.coc`, []);
        setHg(hg);
        setCoc(coc);
      }

      let checkAlreadyAdded = response?.data?.partnerStatus?.filter(
        (item) => item.partnerId == partnerDetails?.id
      );

      const eligiblePartners = _.get(response, "data.eligibleBrands", null);
      const notEligiblePartners = _.get(
        response,
        "data.notEligiblePartners",
        null
      );
      let notEligiblePartnerIds = [];
      if (notEligiblePartners != null) {
        notEligiblePartnerIds = [...Object.keys(notEligiblePartners)].map(
          (id) => Number(id)
        );
      }

      let newFilter = filterEligiblePartners(
        response.data[i18n?.language || "en"],
        eligiblePartners
      );

      let nonEligibleFilter = filterEligiblePartners(
        response.data[i18n?.language || "en"],
        notEligiblePartnerIds
      );
      // console.log("notEligiblePartners", nonEligibleFilter);
      // console.log("newFilter", newFilter);
      setStepCountForEvent(recommendationStepCount);
      setRecommendations(newFilter);
      setNotEligible(nonEligibleFilter);
      // if (initialCount === 1) {
      //   setInitialRecommendation(newFilter);
      //   setInitialCount(2);
      // }
      rec = _.get(response, "data", null);
      let resStatus = _.get(response, "status", "");
      if (resStatus == 200) {
        let internalStatus = _.get(response, "data.status", null);
        if (!preloaded) {
          setInternalStatus(internalStatus);
        }
        if (
          (internalStatus == 2019 ||
            internalStatus == 2020 ||
            internalStatus == 2022) &&
          !preloaded
        ) {
          setDataLoading(true);
        } else {
          setDataLoading(false);
          clearInterval(refreshIntervalId);
          if(recommendationsLoadStartTime) {
            const currentTime = moment();
            const diff = currentTime.diff(recommendationsLoadStartTime, 'milliseconds');
            window?.Moengage?.track_event("recommendtaions_success_load_time", {
              timeDiffInSeconds: diff/1000
            });
            recommendationsLoadStartTime = null;
          }
          setInitialRecommendation(newFilter);
          let interestedBrand = _.get(response, "data.interestedBrands", null);

          interestedBrand =
            interestedBrand?.length > 0 ? interestedBrand[0] : null;

          if (partnerDetails) {
            if (
              partnerDetails?.id &&
              !rec?.eligibleBrands?.includes(Number(partnerDetails?.id))
            ) {
              if (checkAlreadyAdded.length > 0) {
                //  if (
                //    checkAlreadyAdded[0].status !== "rejected" &&
                //    checkAlreadyAdded[0].status !== "pfulfilled" &&
                //    checkAlreadyAdded[0].status !== "fullfilled"
                //  ) {
                //    setExistingAccount(true);
                //    setCloseIcon(true);
                //  }
                if (checkAlreadyAdded[0].status === "rejected") {
                  setExistingAccount(true);
                  setCloseIcon(true);
                  setSelectedPartnerStatus("rejected");
                } else if (
                  checkAlreadyAdded[0].status === "pfulfilled" ||
                  checkAlreadyAdded[0].status === "fullfilled"
                ) {
                  setExistingAccount(true);
                  setCloseIcon(true);
                  setSelectedPartnerStatus("success");
                } else if (
                  checkAlreadyAdded[0].status === "leadadded" ||
                  "actnreqrd" === checkAlreadyAdded[0]?.status
                ) {
                  setExistingAccount(true);
                  setCloseIcon(true);
                  setSelectedPartnerStatus("leadadded");
                }
              } else setBrandInEligible(true);
            } else if (
              partnerDetails?.id &&
              rec?.eligibleBrands?.includes(Number(partnerDetails?.id))
            ) {
              // console.log("customer is eligible");
              //  SMS if LF5 and Lead Form if LF4
              setShouldCallApplyPartner(true);
            }
          }

          // Code to decide if the brand is eligible or not
        }

        // setRecommendations(rec);

        // setDataLoading(false);
      }
    } catch (error) {
      console.log(error);
      setDataLoading(false);
      if(recommendationsLoadStartTime) {
        const currentTime = moment();
        const diff = currentTime.diff(recommendationsLoadStartTime, 'milliseconds');
        window?.Moengage?.track_event("recommendtaions_failed_load_time", {
          timeDiffInSeconds: diff/1000
        });
        recommendationsLoadStartTime = null;
      }
    }
  };

  const recommendationSection = (
    recommendations = [],
    lmsRecommendations = []
  ) => {
    let overallRecommendation = [...lmsRecommendations, ...recommendations];
    // console.log(overallRecommendation,"");
    let actualRecommendations = _(overallRecommendation)
      .groupBy("id")
      .sortBy((id) => overallRecommendation.indexOf(id[0]))
      .map((g) =>
        _.mergeWith({}, ...g, (obj, src) =>
          _.isArray(obj) ? obj.concat(src) : undefined
        )
      )
      .value();

    return actualRecommendations?.map((item, i) => (
      <RecommendationCategoryCardV2
        categoryId={item.id}
        title={item.name}
        brands={item.partners}
        customer={customer}
        key={i}
        notEligible={[...lmsNotEligible, ...notEligible]}
        // ineligibleBrand={ineligibleBrand}
        // setIneligibleBrand={setIneligibleBrand}
        interestsArray={interestsArray}
        customerDetails={customerDetails}
        flags={flags}
        hg={hg}
        coc={coc}
        isCreditScoreCheck={isCreditScoreCheck}
      />
      // <Recommendation
      //   title={item.name}
      //   brands={item.partners}
      //   customer={customer}
      //   key={i}
      // />
    ));
  };
  // console.log(customer, "customer");
  // console.log(customerDetails, "customerDetails");
  const whatsAppMessageTemplate = `${
    customer?.fullName
  },%0ayou can simply start your application process for ${
    partnerDetails?.title
  } by clicking the link down here.%0a${encodeURIComponent(
    lf5Url
  )}%0aNote: This is a self generated link. Do not share it with anyone.`;

  const fetchFields = async () => {
    try {
      const res = await onecodeAPI.get(
        `/criteria/fields?locale=${i18n?.language || "en"}`
      );

      let ddOptions = {
        gender: {
          label: t("addcustomertotalinformation.gender"),
          options: [
            { localizedLabel: "Male", label: "Male", value: "Male" },
            { localizedLabel: "Female", label: "Female", value: "Female" },
          ],
        },
        employerName: {
          options: [],
          label: "Company Name",
        },
        fullName: {
          label: "Full Name",
        },
        email: {
          label: "Email",
        }
      };

      _.forEach(res.data, function (ele) {
        if (ele.criteriaName === "income")
          ddOptions = {
            ...ddOptions,
            annualIncome: {
              options: ele.indexes,
              label: t("addcustomertotalinformation.Monthlyincome"),
            },
          };
        else if (ele.criteriaName === "employmentType")
          ddOptions = {
            ...ddOptions,
            employmentType: {
              options: ele.indexes,
              label: t("addcustomertotalinformation.employmenttype"),
            },
          };
        else if (ele.criteriaName === "modeOfSalary")
          ddOptions = {
            ...ddOptions,
            modeOfIncome: {
              options: ele.indexes,
              label: t("addcustomertotalinformation.modeofincome"),
            },
          };
        else if (ele.criteriaName === "currentOccupation")
          ddOptions = {
            ...ddOptions,
            currentOccupation: {
              options: ele.indexes,
              label: t("addcustomertotalinformation.occupation"),
            },
          };
        else if (ele.criteriaName == "workExperience")
          ddOptions = {
            ...ddOptions,
            workExperience: {
              options: ele.indexes,
              label: "Work Experience",
            },
          };
      });
      setDropDownOptions(ddOptions);
    } catch (error) {
      console.log("error-field", error);
    }
  };
  // const ConditionalFields = () => {
  //   const conditionalFields = [
  //     "currentOccupation",
  //     "workExperience",
  //     "annualIncome",
  //     "modeOfIncome",
  //   ];
  //   additionalFields.forEach((f) => {
  //     if (
  //       customerDetails?.employmentType == "Not Working" &&
  //       conditionalFields.includes(f)
  //     ) {
  //       setIsConditionalField(true);
  //     }
  //   });
  // };

  // const ConditionalFields = () => {
  //   let filteredAdditionalFields = [];
  //   const conditionalFields = [
  //     "currentOccupation",
  //     "workExperience",
  //     "annualIncome",
  //     "modeOfIncome",
  //   ];
  //   additionalFields.forEach((f) => {
  //     if (
  //       customerDetails?.employmentType == "Not Working" &&
  //       conditionalFields.includes(f)
  //     ) {
  //       filteredAdditionalFields.push(f);
  //     }
  //   });
  //   if (filteredAdditionalFields.length > 0) {
  //     setIsConditionalField(false);
  //   }
  // };

  useEffect(() => {
    fetchFields();
    // ConditionalFields();
  }, []);

  // useEffect(() => {
  //   if (additionalFields?.length > 0 && dropDownOptions) {
  //     ConditionalFields();
  //   }
  // }, [additionalFields, dropDownOptions]);

  // console.log(isConditionalField, "isConditionalField");
  return (
    <div style={{ backgroundColor: "#E5E5E5", minHeight: "100%" }}>
      {additionalFields.length > 0 && dropDownOptions ? (
        //  &&
        // !customerDetails?.employmentType != "Not Working" &&
        // additionalFields.includes(
        //   "currentOccupation",
        //   "workExperience",
        //   "annualIncome",
        //   "modeOfIncome"
        // )
        <BackfillModal
          additionalFields={additionalFields}
          customerDetails={customerDetails}
          searchParams={searchParams}
          dropDownOptions={dropDownOptions}
          setCustomerDetails={setCustomerDetails}
        />
      ) : (
        <></>
      )}
      <Header title={t("recommendation.header")} />
      {isCreditScoreCheck ? (
        <CreditScore
          hash={searchParams.get("hash")}
          customerDetails={customer}
          setCustomer={setCustomer}
        />
      ) : (
        <AgentDetails
          setOnecode={setOnecode}
          setCustomer={setCustomer}
          setLoading={setLoading}
          loading={loading}
          recommendationFlow={true}
          brandSpecific={brandSpecific}
          setBrandSpecific={setBrandSpecific}
        />
      )}
      {/* <Congratulations /> */}
      {partnerDetails && brandInEligible && <Ineligilble />}
      {partnerDetails && existingAccount && (
        <Eligilble
          applyToPartner={applyToPartner}
          customer={customer}
          selectedPartnerStatus={selectedPartnerStatus}
          customerDetails={customerDetails}
        />
      )}
      {/* <RecommendationCategoryCardV2 /> */}
      <div
        style={{
          color: "#000000",
          display: "flex",
          justifyContent: "center",
          paddingTop: 10,
          fontSize: 20,
        }}
      >
        {t("recommendation.hello")} {customer?.fullName},
      </div>
      <div
        style={{
          color: "#484848",
          display: "flex",
          justifyContent: "center",
          paddingBottom: 20,
        }}
      >
        {t("recommendation.topPicks")}
      </div>
      {recommendations && (
        <RecommendationFilter
          interestsArray={interestsArray}
          setInterestsArray={setInterestsArray}
          setRecommendations={setRecommendations}
          initialRecommendation={initialRecommendation}
          recommendations={recommendations}
        />
      )}
      <>
        {dataLoading ? (
          <Spin size="large" className="Card6" />
        ) : (
          recommendationSection(recommendations, lmsRecommendations)
        )}
      </>
      <ApplyModal
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        responseStatus={responseStatus}
        partnerDetails={partnerDetails}
        setIsModalVisible={setIsModalVisible}
        customer={customer}
        isBrandSpecific={true}
        LmsCloseIcon={LmsCloseIcon}
        closeIcon={closeIcon}
        link={lf5Url}
        buttonToDisplay={attributionType == "WEB" ? "continue" : "whatsapp"}
        partnerLink={partnerLink}
      />
      {/* <Modal
        maskClosable={false}
        visible={isModalVisible}
        onCancel={handleCancel}
        maskStyle={{
          background: "rgba(0,0,0,0.7)",
        }}
        footer={null}
        centered={true}
        closable={responseStatus == 409 || closeIcon || LmsCloseIcon}
        // closable={true}
        bodyStyle={{
          border: "1px solid  #fff",
          justifySelf: "center",
          borderRadius: "10px",
          padding: "20px",
        }}
        width="90%"
        // closeIcon={<CloseOutlined className="modalCloseBtn" />}
      >
        <p style={{ textAlign: "center", fontSize: "15px", color: "#7D7D7D" }}>
          {responseStatus == 409 ? (
            <DynamicTextFormatter
              textString={t("recommendation.AlreadyApplied")}
              values={{
                __PartnerTitle__: { value: partnerDetails?.title },
              }}
            />
          ) : (
            <> </>
          )}
        </p>
        {responseStatus !== 409 && (
          <div
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              onClick={() => {
                if (responseStatus == 409) {
                  setIsModalVisible(false);
                } else {
                  window.open(
                    `whatsapp://send?text=${whatsAppMessageTemplate}&phone=+91${customer?.phoneNumber}`
                  );
                }
              }}
              style={{
                background: "#00c34e",
                borderRadius: "5px",
                // width: "40%",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                padding: "0.5rem",
                paddingLeft: "0.9rem",
                paddingRight: "0.9rem",
              }}
            >
              <p
                style={{
                  color: "#6C63FF",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 0,
                  padding: 0,
                }}
              >
                {responseStatus == 409 ? (
                  "Ok"
                ) : (
                  <>
                    <RiWhatsappFill
                      style={{
                        color: "#FFF",
                        // color: "#25D366",
                        fontSize: "15px",
                      }}
                    />
                    <p
                      style={{
                        color: "#FFF",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        marginBottom: 0,
                        padding: 0,
                        marginLeft: "5px",
                      }}
                    >
                      Generate Link
                    </p>
                  </>
                )}
              </p>
            </button>
          </div>
        )}
      </Modal> */}
      {isEligibleModalVisible && (
        <Modal
          visible={isEligibleModalVisible}
          onCancel={handleEligiblePopupCancel}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Not Eligible
          </p>
          {brandNotEligibleReasons?.map((item, key) => (
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              {key + 1}. {item}
            </p>
          ))}
        </Modal>
      )}
      {emailHandlePopup && (
        <Modal
          visible={emailHandlePopup}
          onCancel={hideEmailHandlePopup}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Invalid Email ID!
          </p>

          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
            }}
          >
            Email already exists OR invalid characters/length/domain in Email,
            please ask your Business Consultant to update the email ID and apply
            again.
          </p>
          <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                hideEmailHandlePopup();
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Ok, got it.
            </button>
          </div>
        </Modal>
      )}
      {handelContentModal && (
          <ContentModal
            modalVisible={handelContentModal}
            popupContent={responsePopContent}
            setHandelContentModal={setHandelContentModal}
            // popupContent={"suupppp"}
          />
        )}
    </div>
  );
}
